import { createStore } from 'vuex'
import settings from './modules/settings.js'
import summary from './modules/summary.js'

export default createStore({
    modules: {
        settings,
        summary
    }
})